module.exports = __webpack_public_path__ + "e16a905eb12173f7df1c0cb01d299477.svg";